import { explicitMaybe } from '@execonline-inc/decoders';
import { array, dateISO, Decoder, field, number, string, succeed } from 'jsonous';
import { readonlyArray } from '../../../../../../../Decoders';
import { resourceDecoder } from '../../../../../../../Resource/Decoders';
import { groupMemberDecoder } from '../../../Stores/ShareStore/Decoders';
import { ParticipantsResource, User, UserGroup, UserGroupsResource } from './Types';

const userPayloadDecoder: Decoder<User> = succeed({})
  .assign('id', field('id', number))
  .assign('firstName', field('first_name', string))
  .assign('lastName', field('last_name', string))
  .assign('email', field('email', string))
  .assign('licenseCount', field('license_count', number))
  .assign('learningCollectionCount', field('learning_collection_count', number))
  .assign('lastLogin', field('last_login', explicitMaybe<Date>(dateISO)));

const userResourceDecoder: Decoder<User> = field('payload', userPayloadDecoder);

const userGroupPayloadDecoder: Decoder<UserGroup> = succeed({})
  .assign('id', field('id', number))
  .assign('name', field('name', string))
  .assign('members', field('members', readonlyArray(groupMemberDecoder)));

const userGroupResourceDecoder: Decoder<UserGroup> = field('payload', userGroupPayloadDecoder);

const participantsPayloadDecoder = succeed({}).assign(
  'participants',
  field('participants', array(userResourceDecoder)),
);

const userGroupsPayloadDecoder = succeed({}).assign(
  'userGroups',
  field('user_groups', array(userGroupResourceDecoder)),
);

export const participantsResourceDecoder: Decoder<ParticipantsResource> = resourceDecoder(
  participantsPayloadDecoder,
);

export const userGroupsResourceDecoder: Decoder<UserGroupsResource> =
  resourceDecoder(userGroupsPayloadDecoder);
